/* BeanBurds — equipment collection system. 28 Aug 2026.
   Loaded once (defer) from layout/theme.liquid on collection.bb-equip-* templates.
   Handles: hero read-more, facet dropdowns, add-to-bag (same /cart/add.js path and
   header-bubble selectors as bb-coffee.js), "Get quote" pre-fill, guided finder modal.
   No GA4 add_to_cart here — the parent theme already fires it on /cart/add.js. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var app = $('#bbe-app');

  /* ---- hero read-more ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bbe-more]');
    if (!b) return;
    var full = document.getElementById(b.getAttribute('aria-controls'));
    var open = !full.classList.contains('is-open');
    full.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', String(open));
    b.textContent = open ? b.getAttribute('data-open') : b.getAttribute('data-closed');
  });

  /* ---- facet dropdowns: one open at a time, close on outside click / Esc ---- */
  function closeFacets(except) {
    $$('[data-bbe-facet][open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches('[data-bbe-facet]') && d.open) closeFacets(d);
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-bbe-facet]')) closeFacets();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFacets(); });
  $$('.bbe-price').forEach(function (f) {
    f.addEventListener('submit', function () {
      var a = f.querySelector('input[name$=".gte"]'), b = f.querySelector('input[name$=".lte"]');
      if (a && b && a.value && b.value && +a.value > +b.value) { var t = a.value; a.value = b.value; b.value = t; }
      [a, b].forEach(function (i) { if (i && !i.value) i.disabled = true; });
    });
  });

  /* ---- empty state: Liquid cannot see the query string, so correct the wording
     here when the grid was emptied by a filter — including a filter Shopify applied
     but dropped from collection.filters because no product in the collection
     carries the field. ---- */
  (function () {
    var e = $('[data-bbe-empty]');
    if (!e || !e.getAttribute('data-filtered-msg')) return;
    if (location.search.indexOf('filter.') === -1) return;
    var url = e.getAttribute('data-collection-url') || location.pathname;
    var p1 = document.createElement('p'); p1.textContent = e.getAttribute('data-filtered-msg');
    var p2 = document.createElement('p');
    var a = document.createElement('a'); a.href = url; a.textContent = e.getAttribute('data-filtered-cta');
    p2.appendChild(a); e.textContent = ''; e.appendChild(p1); e.appendChild(p2);
  })();

  /* ---- circles: mark the one whose query matches the current URL ---- */
  (function () {
    var circles = $$('[data-bbe-circle]');
    if (!circles.length) return;
    var here = decodeURIComponent(location.search.replace(/^\?/, ''));
    circles.forEach(function (a) {
      var q = (a.getAttribute('href') || '').split('?')[1];
      if (!q) return;
      var ok = decodeURIComponent(q).split('&').every(function (pair) { return here.indexOf(pair) !== -1; });
      if (ok) a.setAttribute('aria-current', 'true');
    });
  })();

  /* ---- toast ---- */
  var toastT;
  function toast(msg) {
    var t = document.getElementById('bbe-toast');
    if (!t) { t = document.createElement('div'); t.id = 'bbe-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('is-show'); });
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* ---- header cart bubble (mirrors bb-coffee.js so the count updates the same way everywhere) ---- */
  function updateCartBubble(n) {
    var txt = n < 100 ? String(n) : '99+';
    $$('.bb-cartbadge').forEach(function (el) { el.textContent = txt; });
    $$('.bb-icb.bb-cart, .bb-meta-item.bb-meta-cart').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
    $$('.cart-bubble__text-count').forEach(function (el) { el.textContent = n < 100 ? String(n) : ''; el.classList.toggle('hidden', n === 0); });
    $$('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', n === 0); });
    $$('cart-icon').forEach(function (el) { el.classList.toggle('header-actions__cart-icon--has-cart', n > 0); });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* ---- add to bag ---- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-bbe-add]');
    if (!add || add.hasAttribute('disabled')) return;
    e.preventDefault();
    var vid = parseInt(add.getAttribute('data-bbe-add'), 10);
    var name = add.getAttribute('data-name') || 'Item';
    add.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js').then(function (x) { return x.json(); }); })
      .then(function (cart) { updateCartBubble(cart.item_count || 0); add.textContent = 'Added ✓'; toast(name + ' added to your bag.'); })
      .catch(function () { window.location.href = add.getAttribute('data-url') || '/cart'; })
      .then(function () { add.disabled = false; });
  });

  /* ---- "Get quote" pre-fills the lead form's context field ---- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-bbe-quote]');
    if (!q) return;
    var ctx = $('[data-bbe-context]');
    if (ctx) { ctx.value = q.getAttribute('data-bbe-quote'); setTimeout(function () { ctx.focus({ preventScroll: true }); }, 400); }
  });

  /* ---- guided finder ---- */
  var dataEl = document.getElementById('bbe-finder-data');
  var overlay = $('[data-bbe-finder]');
  if (dataEl && overlay) {
    var data; try { data = JSON.parse(dataEl.textContent); } catch (err) { data = null; }
    if (data) {
      data.questions = (data.questions || []).map(function (q) {
        return { label: q.label, options: String(q.options || '').split(/\r?\n/).map(function (l) {
          var p = l.split('|'); var lbl = (p[0] || '').trim(); if (!lbl) return null;
          return { label: lbl, q: (p[1] || '').trim() };
        }).filter(Boolean) };
      }).filter(function (q) { return q.label && q.options.length; });

      var modal = $('.bbe-modal', overlay), step = 0, answers = [], lastFocus = null;
      var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

      function firstProduct() {
        var c = $('[data-bbe-card]');
        if (!c) return null;
        var img = $('.bbe-media img', c), t = $('h3 a', c), pb = $('.bbe-price-block b', c), ps = $('.bbe-price-block span', c), br = $('.bbe-brand', c);
        return { img: img ? img.currentSrc || img.src : '', alt: img ? img.alt : '', title: t ? t.textContent : '', url: t ? t.href : '#', price: pb ? pb.textContent : '', note: ps ? ps.textContent : '', brand: br ? br.textContent : '' };
      }
      function resultUrl() {
        var qs = answers.map(function (a) { return a.q; }).filter(Boolean);
        if (!qs.length) return data.url + '#bbe-products';
        return data.url + '?' + qs.join('&') + '#bbe-products';
      }
      function render() {
        var n = data.questions.length, last = step >= n;
        var head = '<div class="bbe-fhead"><div><span class="bbe-eyebrow">Guided finder · ' + esc(data.label) + '</span><b>' + (last ? 'Your starting point' : 'Step ' + (step + 1) + ' of ' + n) + '</b></div><button type="button" class="bbe-iconbtn" data-bbe-close aria-label="Close">✕</button></div>' +
          '<div class="bbe-progress" style="--bbe-steps:' + n + '">' + data.questions.map(function (q, i) { return '<span class="' + (i <= step ? 'is-on' : '') + '"></span>'; }).join('') + '</div>';
        var body;
        if (!last) {
          var q = data.questions[step];
          body = '<div class="bbe-fq"><h2 id="bbe-finder-title">' + esc(q.label) + '</h2><div class="bbe-fopts">' +
            q.options.map(function (o, i) { return '<button type="button" data-bbe-answer="' + i + '"><span>' + esc(o.label) + '</span><span aria-hidden="true">→</span></button>'; }).join('') + '</div></div>';
        } else {
          var p = firstProduct();
          body = '<div class="bbe-fr"><span class="bbe-eyebrow">' + esc(data.resultLabel) + '</span>' +
            (p ? '<div class="bbe-result"><img src="' + esc(p.img) + '" alt=""><div><span class="bbe-brand bbe-eyebrow">' + esc(p.brand) + '</span><h3 id="bbe-finder-title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><p>' + esc(p.price) + (p.note ? ' · ' + esc(p.note) : '') + '</p></div></div>' : '<h2 id="bbe-finder-title">Your matches</h2>') +
            '<div class="bbe-answers">' + answers.map(function (a) { return '<span class="bbe-chip">' + esc(a.label) + '</span>'; }).join('') + '</div>' +
            '<a class="bbe-btn is-pine" href="' + esc(resultUrl()) + '" data-bbe-go>View matching products →</a></div>';
        }
        var foot = '<div class="bbe-ffoot"><button type="button" data-bbe-back' + (step === 0 ? ' disabled' : '') + '>← Back</button><span>This guided flow is separate from the collection page.</span></div>';
        modal.innerHTML = head + body + foot;
        var f = $('[data-bbe-answer], [data-bbe-go]', modal); if (f) f.focus();
      }
      function open() { lastFocus = document.activeElement; step = 0; answers = []; overlay.hidden = false; document.body.style.overflow = 'hidden'; render(); }
      function close() { overlay.hidden = true; document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }

      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-bbe-finder-open],[data-bbe-close],[data-bbe-back],[data-bbe-answer],[data-bbe-go]');
        if (t) {
          if (t.hasAttribute('data-bbe-finder-open')) { e.preventDefault(); open(); }
          else if (t.hasAttribute('data-bbe-close')) close();
          else if (t.hasAttribute('data-bbe-back')) { if (step > 0) { step--; answers.pop(); render(); } }
          else if (t.hasAttribute('data-bbe-answer')) { answers.push(data.questions[step].options[+t.getAttribute('data-bbe-answer')]); step++; render(); }
          else if (t.hasAttribute('data-bbe-go')) { var same = t.getAttribute('href').split('#')[0] === location.pathname + location.search; if (same) { e.preventDefault(); close(); var g = $('#bbe-products'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
          return;
        }
        if (e.target === overlay) close();
      });
      document.addEventListener('keydown', function (e) {
        if (overlay.hidden) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Tab') {
          var f = $$('button:not([disabled]), a[href]', modal); if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    } else {
      $$('[data-bbe-finder-open]').forEach(function (b) { b.hidden = true; });
    }
  } else {
    $$('[data-bbe-finder-open]').forEach(function (b) { b.hidden = true; });
  }
})();
